import React, { useState, useCallback, useRef, useEffect, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../../../../context/alert';
import { useUserContext } from '../../../../context/user';
import { useDeletePostsMutation } from '../../../../hooks/useForumQuery';
import { PostResponse } from '../../../../types/api/forum';
import { formatDate } from '../../../../helpers/dates';
import ModalSheet from '../../../basic/ModalSheet';
import { UserHeaderCard } from '../../../basic/UserHeaderCard';
import MediaPreview from '../../../common/MediaPreview';
import { Stack, Button, Text } from '@primer/react'

interface ForumCommentModalProps {
    post: PostResponse
    isOpen: boolean;
    onDidDelete: () => void;
    onClose: () => void;
}

export const ForumCommentModal: React.FC<ForumCommentModalProps> = ({ post, isOpen, onDidDelete, onClose }) => {

    const navigate = useNavigate();
    const { setSuccess } = useAlert();

    const { mutate: deleteCommentRequest, isPending: isDeletingProcess } = useDeletePostsMutation(() => {
        setSuccess(`Комментарий удален`);
        onDidDelete();
    });

    const media = post.media

    return (
        <ModalSheet
            isOpen={isOpen}
            onClose={onClose}
            title="Комментарий"
            size="middle"
            headerSize="regular"
        >
            {({ setTitle }) => (
                <Stack className='mt-[16px]'>
                    <div className="bg-header border border-border rounded-lg w-full mb-2">
                        <div className="bg-white w-full rounded-t-lg border-b">
                            <div className="p-4">
                                <UserHeaderCard
                                    user={post.user}
                                    isLarge={false}
                                    isSupport={false}
                                    onClick={() => navigate('/users/user?id=' + post.user.id)} />
                            </div>
                        </div>

                        <div className="bg-header w-full rounded-b-lg border-b">
                            <div className="ml-[14px] mr-[14px] mb-4">
                                <Stack direction="horizontal" justify="space-between" gap="condensed">
                                    <Stack direction="horizontal" align="center" gap="condensed">
                                        <Text className='text-[14px] text-aloix-grey ml-1 mt-3 break-words'>
                                            {post.content}
                                        </Text>
                                    </Stack>
                                </Stack>
                                <Text className='text-[14px] text-aloix-grey ml-1 block mt-[10px] break-words'>
                                    Дата размещения — {formatDate(post.createdAt)}
                                </Text>
                                {media && <MediaPreview images={media} className='mt-2' />}
                            </div>
                        </div>
                    </div>
                    <Stack direction="horizontal" gap='normal' justify='end'>
                        <div></div>
                        {
                            <Button
                                onClick={() => deleteCommentRequest({ ids: [post.id] })}
                                size='small'
                                loading={isDeletingProcess}
                                variant="danger">
                                Удалить комментарий
                            </Button>
                        }
                    </Stack>
                </Stack>
            )
            }
        </ModalSheet >
    );
};